import React from 'react';
import { Provider } from 'react-redux';

import { BaseConfig } from '@eika-infrastruktur/config-provider';
import { loadContainers } from '@eika-infrastruktur/render';

import { defaultFormConfig } from '../default-config';
import configureStore from './configure-store';
import ContactForm from './containers/contactForm';

const store = configureStore();

require('./styles/main.scss');

const renderApp = <T extends BaseConfig>(MyApp: React.ComponentType<T>, namespace: string, appConfig: T) => {
    loadContainers(
        namespace,
        ({ config }) => (
            <Provider store={store}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <MyApp {...config} />
            </Provider>
        ),
        appConfig,
    );
};

renderApp(ContactForm, 'dagligbank-contact-form-web', defaultFormConfig);
